import { IAppState } from 'store';

export const selectState = (state: IAppState) => state.screen.manualEnrolment;

